"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridSize = exports.breakpoints = void 0;
var breakpoints = ['xs', 'sm', 'md', 'lg'];
exports.breakpoints = breakpoints;
var gridSize = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
exports.gridSize = gridSize;